import { useTranslation as useTranslationOriginal } from 'react-i18next';

// Supported namespaces
export type Namespace = 'common' | 'validation' | 'navigation' | 'customers' | 'objects' | 'dashboard' | 'services' | 'employees' | 'tasks' | 'absences' | 'planning' | 'profile' | 'auth' | 'header' | 'priceIndex' | 'workScheduleModels' | 'reports' | 'myplan' | 'timeclock' | 'offers' | 'invoices' | 'textSnippets' | 'tenantSettings' | 'absenceSettings' | 'errors' | 'admin' | 'public' | 'support' | 'subscription' | 'import' | 'contractImport' | 'releaseNotes' | 'myChecklists' | 'checklistProtocol' | 'vehicles' | 'openItems' | 'timeClockGroups';

// Re-export useTranslation with type safety
export function useTranslation(ns?: Namespace | Namespace[]) {
  return useTranslationOriginal(ns);
}

// Export i18n instance for direct access
export { default as i18n } from './config';
